export type LegalDocumentKey = "privacy" | "terms";

export function normalizePublicPath(pathname: string): string {
  return pathname.replace(/\/+$/, "") || "/";
}

export function legalDocumentForPath(pathname: string): LegalDocumentKey | null {
  const normalized = normalizePublicPath(pathname);
  if (normalized === "/privacy") return "privacy";
  if (normalized === "/terms") return "terms";
  return null;
}

export function isLegalPath(pathname: string): boolean {
  return legalDocumentForPath(pathname) !== null;
}
